import React from 'react';

const EmptyState = ({ icon = '📋', title = 'No Results Found', description = '' }) => (
  <div className="fr-empty-state">
    <span className="fr-empty-icon">{icon}</span>
    <h2 className="fr-empty-title">{title}</h2>
    {description && <p className="fr-empty-description">{description}</p>}
  </div>
);

export default EmptyState;